/** Mix Desk API — per-song mix + mastering settings, server renders kept as numbered mixes (owner session cookie). */
import axios from "axios";
import { API } from "@/lib/creatorApi";

const studio = axios.create({ baseURL: `${API}/studio`, withCredentials: true });
const data = (p) => p.then((r) => r.data);

export const getMix = (songId) => data(studio.get(`/songs/${songId}/mix`));
export const saveMix = (songId, settings) => data(studio.put(`/songs/${songId}/mix`, { settings }));
export const renderMix = (songId, settings) => data(studio.post(`/songs/${songId}/mix/render`, { settings }));
export const deleteMixVersion = (songId, versionId) => data(studio.delete(`/songs/${songId}/mix/versions/${versionId}`));
export const listMixes = () => data(studio.get("/mixes"));
export const saveSongTempo = (songId, tempo) => data(studio.put(`/songs/${songId}/tempo`, tempo));

export const MIX_PHASES = {
  starting: "Getting ready",
  loading: "Gathering the parts",
  mixing: "Mixing & mastering",
  saving: "Saving WAV + MP3",
  done: "Done",
  error: "Stopped",
};

export const TRACK_LABELS = { vocals: "AI Vocals", drums: "Drums", bass: "Bass", piano: "Piano / Keys", guitar: "Guitar", other: "Everything else", take: "Your Voice" };

export const dbToGain = (db) => 10 ** (db / 20);

/** The parts that sound: soloed ones if any are soloed, otherwise every unmuted one. */
export function audibleTracks(tracks, names) {
  const solo = names.filter((n) => tracks[n]?.solo);
  return solo.length ? solo : names.filter((n) => !tracks[n]?.mute);
}

export const fmtLufs = (v) => (v == null ? "—" : `${v.toFixed(1)} LUFS`);
export const fmtDb = (v, digits = 1) => `${v > 0 ? "+" : ""}${Number(v).toFixed(digits)} dB`;
export const fmtPan = (p) => (Math.abs(p) < 0.02 ? "C" : `${p < 0 ? "L" : "R"}${Math.round(Math.abs(p) * 100)}`);

export const STAGES = [
  { key: "idea", label: "Idea", tone: "border-slate-300/40 bg-slate-400/10 text-slate-100" },
  { key: "writing", label: "Writing", tone: "border-sky-300/40 bg-sky-500/10 text-sky-100" },
  { key: "recording", label: "Recording", tone: "border-rose-300/40 bg-rose-500/10 text-rose-100" },
  { key: "mixing", label: "Mixing", tone: "border-amber-300/40 bg-amber-500/10 text-amber-100" },
  { key: "finished", label: "Finished", tone: "border-emerald-300/40 bg-emerald-500/10 text-emerald-100" },
];
export const stageOf = (key) => STAGES.find((s) => s.key === key) || null;
